<template>
    <div class="md:grid md:grid-cols-3 md:gap-6">
        <div class="md:col-span-1">
            <div class="px-4 sm:px-0">
                <h3 class="text-lg font-medium leading-6 text-gray-900">Stripe setup</h3>
                <p class="mt-1 text-sm leading-5 text-gray-600">
                    Payout destination
                </p>
            </div>
        </div>
        <div class="mt-5 md:mt-0 md:col-span-2">
            <div class="shadow overflow-hidden sm:rounded-md">
                <div class="px-4 py-5 bg-white sm:p-6">
                    <p class="block text-sm leading-5 font-medium text-gray-700">
                        Status: <strong>{{ connected ? 'Connected': 'Not yet connected' }}</strong>
                    </p>
                    <p v-if="!connected" class="mt-2">
                    <a :href="url"><img :src="$page.assetUrl + '/images/stripe-blue-on-dark@3x.png'" class="h-8" alt="Connect with Stripe"></a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "EditStripe",
        props: {
            url: String,
            connected: { type: Boolean, default: true }
        }
    }
</script>
